<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Detalle por tramo (ida / vuelta), armado con los segmentos reales que
       FlyProductService guardó en item.itinerary. No hay precio ni status
       por tramo: item es una única tarifa que cubre todo el itinerario. -->
  <ng-container *ngFor="let leg of item.itinerary; let lastLeg = last">
    <hr *ngIf="!lastLeg" class="w-100" style="border: none; border-top: 1px solid #000000; margin: 14px 0;" />

    <ng-container *ngFor="let segment of getSegments(leg); let segmentIndex = index; let lastSegment = last">
      <hr *ngIf="segmentIndex > 0" class="w-100" style="border: none; border-top: 1px solid #e0e0e0; margin: 14px 0;" />

      <p *ngIf="getSegments(leg).length > 1" class="segment-label mb-2">
        {{ getSegmentLabel(segmentIndex) }}
      </p>

      <div class="d-flex mb-3">
        <div class="d-flex flex-column w-100">
          <span class="detail-label">Origen: {{ segment?.departure?.airport }}</span>
          <p class="detail-date">{{ segment?.departure?.dateTime | date: "EEE. dd MMM yyyy" : undefined : "es" }}</p>
          <span class="detail-time">{{ segment?.departure?.dateTime | date: "HH:mm" }} hs</span>
        </div>
        <div class="d-flex flex-column w-100">
          <span class="detail-label">Destino: {{ segment?.arrival?.airport }}</span>
          <p class="detail-date">{{ segment?.arrival?.dateTime | date: "EEE. dd MMM yyyy" : undefined : "es" }}</p>
          <span class="detail-time">{{ segment?.arrival?.dateTime | date: "HH:mm" }} hs</span>
        </div>
      </div>

      <div class="d-flex  mb-3">
        <span class="detail-item-label w-100">
          <p class="mb-0">Tiempo de Vuelo: </p>
          <p class="mb-0"><strong>{{ formatDuration(getSegmentDuration(segment)) }}</strong></p>
        </span>
        <span class="detail-item-label w-100">
          <p class="mb-0"> Tiempo de Escala: </p>
          <p class="mb-0">    <strong>
            {{ lastSegment ? 'Sin Escalas' : formatDuration(getSegmentLayoverMinutes(getSegments(leg), segmentIndex)) }}
          </strong></p>


        </span>
      </div>

      <div class="d-flex  mb-3">
        <span class="detail-item-label w-100">
          <div class="d-flex align-items-center">
             <img class="cabin-icon" src="../../../../../../assets/icons/search-result/aereo/cabina-01.svg" alt="" />

              <p class="mb-0"> Cabina: </p>
          </div>

          <p class="mb-0"><strong>{{ segment?.cabin?.category | titlecase }}</strong></p>

        </span>
        <span class="detail-item-label w-100">
            <p class="mb-0"> Nro de Vuelo: </p>
          <p class="mb-0"><strong>{{ segment?.airline?.code }} {{ segment?.flightNumber }}</strong></p>

        </span>
      </div>

      <div class="include-row mb-2">
        <span>Incluye</span>
        <img class="include-icon" [class.not-included]="!hasRefund()" src="../../../../../../assets/icons/search-result/aereo/devolucion-01.svg" tooltip="Devolución" alt="Devolución" />
        <img class="include-icon" [class.not-included]="!hasChanges()" src="../../../../../../assets/icons/search-result/aereo/cambio-01.svg" tooltip="Cambios" alt="Cambios" />
        <img class="include-icon" [class.not-included]="!hasHandBag()" src="../../../../../../assets/icons/search-result/aereo/backpack-01.svg" tooltip="Equipaje de mano" alt="Equipaje de mano" />
        <img class="include-icon" [class.not-included]="!hasCheckedBag()" src="../../../../../../assets/icons/search-result/aereo/maleta-01.svg" tooltip="Equipaje despachado" alt="Equipaje despachado" />
        <i class="bi bi-person-check-fill" [class.not-included]="!hasSeat()" tooltip="Selección de asiento"></i>
        <i class="bi bi-cup-straw" [class.not-included]="!hasMeal()" tooltip="Comida a bordo"></i>
      </div>
    </ng-container>
  </ng-container>
</usb-base-item>
